import React from 'react'

const HeaderSocials = () => {
  return (
    <div className='home_socials'>
      <a href="https://www.instagram.com/raj_ypandey?igsh=MXF6ODEzZmZqc3hoMg==" className='home_social-link' target="_blank" rel="noreferrer">
        <i className="fa-brands fa-square-instagram"></i>
      </a>

      <a href="https://www.linkedin.com/in/yash-raj-pandey-278b94220/" className='home_social-link' target="_blank" rel="noreferrer">
        <i className="fa-brands fa-linkedin"></i>
      </a>

      <a href="https://leetcode.com/u/Pandey_3011/" className='home_social-link' target="_blank" rel="noreferrer">
        <i class="fa-solid fa-code"></i>
      </a>

      <a href="https://github.com/yashraj132" className='home_social-link' target="_blank" rel="noreferrer">
        <i className="fa-brands fa-github"></i>
      </a>

    </div>
  )
}

export default HeaderSocials
